export default __webpack_public_path__ + "assets/icon-done-circle.f7ad7f08.webp";